import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { NWClient } from '../../client/NWClient';
import {
  AIDocumentContractParams,
  AIDocumentContractModelWithId,
} from '../../models/ai.document.contract.model';
import { revertAll, RootState } from '../../store';

export const fetchAnotherUserDocumentContracts = createAsyncThunk(
  'documentContractsAnotherUser/fetchDocumentContracts',
  async ({ data }: AIDocumentContractParams) => {
    const response = await NWClient.list('document-contract', data);
    return response;
  }
);

/*export const deleteAnotherUserDocumentContract = createAsyncThunk(
  'documentContractsAnotherUser/deleteDocumentContract',
  async ({ id, userId }: AIDocumentContractDeleteData) => {
    const response = await NWClient.delete('document-contract', id, null, { user: userId });
    return response;
  }
);*/

export interface DocumentContractsState {
  documentContractsAnotherUserList: AIDocumentContractModelWithId[];
  status: string;
  error: string | null;
}

const documentContractsArray: AIDocumentContractModelWithId[] = [];
const initialState: DocumentContractsState = {
  documentContractsAnotherUserList: documentContractsArray,
  status: 'idle',
  error: '',
};
const documentContractsAnotherUserSlice = createSlice({
  name: 'documentContractsAnotherUser',
  initialState,
  reducers: {
    clearAnotherUserGeneratedDocuments(state) {
      state.documentContractsAnotherUserList = [];
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchAnotherUserDocumentContracts.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAnotherUserDocumentContracts.fulfilled, (state, action) => {
        state.status = 'succeeded';
        if (Array.isArray(action.payload)) {
          state.documentContractsAnotherUserList = [...action.payload];
        }
      })
      .addCase(fetchAnotherUserDocumentContracts.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || null;
      })
      .addCase(revertAll, () => initialState);
  },
});

export default documentContractsAnotherUserSlice.reducer;
export const { clearAnotherUserGeneratedDocuments } = documentContractsAnotherUserSlice.actions;
export const selectAllAnotherUserDocumentContracts = (state: RootState) =>
  state.documentContractsAnotherUser.documentContractsAnotherUserList;
